var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3434_6004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3338 7.113C23.3098 6.42 24.1308 5.555 24.7998 4.559V4.558C23.9068 4.949 22.9568 5.209 21.9648 5.335C22.9848 4.726 23.7638 3.769 24.1298 2.616C23.1788 3.183 22.1288 3.583 21.0098 3.807C20.1068 2.845 18.8198 2.25 17.4158 2.25C14.6918 2.25 12.4988 4.461 12.4988 7.171C12.4988 7.561 12.5318 7.936 12.6128 8.293C8.5228 8.093 4.9028 6.133 2.4708 3.146C2.0468 3.883 1.7968 4.726 1.7968 5.633C1.7968 7.337 2.6738 8.847 3.9828 9.722C3.1918 9.707 2.4168 9.477 1.7598 9.116V9.17C1.7598 11.561 3.4648 13.547 5.7018 14.005C5.3008 14.115 4.8648 14.167 4.4118 14.167C4.0968 14.167 3.7788 14.149 3.4808 14.083C4.1178 16.031 5.9278 17.464 8.0778 17.511C6.4038 18.82 4.2778 19.609 1.9768 19.609C1.5738 19.609 1.1868 19.591 0.799805 19.542C2.9798 20.947 5.5618 21.75 8.3478 21.75C17.0308 21.75 22.6898 14.506 22.3338 7.113V7.113Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3434_6004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.06b332e96b108c4272b9d337b962d98d.svg";
export { ForwardRef as ReactComponent };